import { useEffect } from "react";
import { executeQuery, useServersStore, addQuery, useAppStore } from "../store";

export function useKeyboardShortcuts() {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const meta = e.metaKey || e.ctrlKey;

      // Cmd+Enter — Execute query (global fallback — skip if a CodeMirror editor already handled it)
      if (meta && e.key === "Enter") {
        if (e.defaultPrevented) return;
        e.preventDefault();
        executeQuery();
        return;
      }

      // Cmd+S — Save current query (auto-save handles this, but prevent browser save dialog)
      if (meta && e.key === "s") {
        e.preventDefault();
        return;
      }

      // Cmd+N — New query
      if (meta && e.key === "n") {
        e.preventDefault();
        const { activeServerId } = useServersStore.getState();
        if (activeServerId) {
          addQuery(activeServerId);
        }
        return;
      }

      // Cmd+P — Quick Open
      if (meta && e.key === "p") {
        e.preventDefault();
        const { showQuickOpen, setShowQuickOpen } = useAppStore.getState();
        setShowQuickOpen(!showQuickOpen);
        return;
      }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);
}
